module.exports = __webpack_public_path__ + "img/sensor_fault.d756759a.svg";